  <!-- Modal-like card -->
  <div class=" rounded-none shadow-2xl overflow-hidden">
    <!-- Header -->
    <div class="bg-orange-50 px-8 py-6 text-center border-b border-gray-100 rounded-none">
      <div class="flex justify-end">
        <mat-icon class="material-symbols-outlined cursor-pointer" (click)="dialogRef.close()">close</mat-icon>
      </div>
      <h2 class="text-[30px] font-bold uppercase tracking-wider text">
        <span class="text-[#636068]">
          {{
          isResetPasswordMode ? 'Créez' :
          isResetMode         ? 'Mot de passe' :
          isLoginMode         ? 'Connectez-vous' :
          'Créez'
          }}
        </span>
        <span class="text-primary">
          {{
          isResetPasswordMode ? 'nouveau mot de passe' :
          isResetMode         ? 'oublié' :
          isLoginMode         ? 'à votre compte' :
          'votre compte'
          }}
        </span>
      </h2>
      <p class="mt-2 text-lg text-gray-700 font-medium">
        Facile comme jamais 😎
      </p>
    </div>

    <!-- Form -->
    <mat-dialog-content>

      <!-- LOGIN FORM -->
      @if (isLoginMode && !isResetMode &&!isResetPasswordMode) {
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="flex flex-col gap-[10px]">
          <!-- Email -->
          <div class="">
            <label for="email" class="block text-sm font-medium text-site mb-2">
              E-mail <span class="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="votre.email@exemple.com"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
              />
            </div>
            <!-- Password -->
            <div class="relative">
              <label for="password" class="block text-sm font-medium text-site mb-2">
                Mot de passe <span class="text-red-500">*</span>
              </label>
              <input
                [type]="hide ? 'password' : 'text'"
                id="password"
                formControlName="password"
                placeholder="Votre mot de passe"
                class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg outline-none transition"
                />
                <!-- Icone dans l’input -->
                <mat-icon
                  (click)="hide = !hide"
                  class="cursor-pointer text-[#7FABFF] absolute right-4 bottom-3"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide">
                  {{ hide ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </div>
              <!-- Forgot password -->
              <div class="flex items-center justify-end  text-sm">
                <a  class="text-primary  hover:text-primary-700 font-medium cursor-pointer"
                  (click)="forgotPassword()">
                  Mot de passe oublié ?
                </a>
              </div>
              <!-- Submit button -->
              <button
                [matButton]="themeConfig.appearance.button.action"
                type="submit"
          class="w-full"
                >
                <span class="flex items-center gap-2">
                  @if (isSubmitting) {
                    <mat-spinner diameter="22"></mat-spinner>
                  }
                  {{ isSubmitting ? 'Connexion...' : 'Se Connecter' }}
                </span>

              </button>
              <div class="text-center">
                <span class="text-gray-600">Vous n'avez pas un compte ? </span>
                <a (click)="toggleMode()"
                  class="text-primary hover:text-orange-700 font-semibold underline cursor-pointer">
                  Inscrivez-vous
                </a>
              </div>
            </form>
          }
          @if (isResetMode && !isResetPasswordMode) {
            <form
              [formGroup]="resetForm"
              (ngSubmit)="onResetPassword()"
              class="flex flex-col gap-6">
              <div class="text-center mb-4">
                <!--          <h3 class="text-xl font-bold text-gray-800">Réinitialiser le mot de passe</h3>-->
                <p class="text-gray-600 mt-2">
                  Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.
                </p>
              </div>
              <div>
                <label class="block text-sm font-medium text-site mb-2">
                  E-mail <span class="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email1"
                  formControlName="email"
                  placeholder="votre.email@exemple.com"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg  outline-none transition"
                  />
                </div>
                <button type="submit"
                  [matButton]="themeConfig.appearance.button.action"
                  [disabled]="resetForm.invalid || isSubmitting"
                class=" w-full">
                  <span class="flex items-center justify-center gap-2">
                    @if (isSubmitting) {
                      <mat-spinner diameter="22"></mat-spinner>
                    }
                    {{ isSubmitting ? 'Envoi...' : 'Envoyer le lien' }}
                  </span>
                </button>
                <!-- Retour au login -->
                <div class="text-center text-sm">
                  <a (click)="isResetMode = false; isLoginMode = true; resetForm.reset()"
                    class="text-primary hover:text-orange-700 font-medium cursor-pointer">
                    ← Retour à la connexion
                  </a>
                </div>
              </form>
            }

            <!-- REGISTER FORM -->
            @if (!isLoginMode && !isResetMode && !isResetPasswordMode) {
              <form [formGroup]="registerForm" (ngSubmit)="onRegister()" class="flex flex-col gap-[10px]">
                <!-- First Name & Last Name -->
                <div class="grid md:grid-cols-2 gap-4">
                  <div>
                    <label for="gender" class="block text-sm font-medium text-site mb-2">
                      Civilité<span class="text-red-500">*</span>
                    </label>
                    <mat-select
                      id="gender"
                      formControlName="gender"
                      placeholder="Sélectionner une civilité"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
                      >
                      <mat-option value="">Sélectionnez</mat-option>
                      <mat-option value="MALE">Mr</mat-option>
                      <mat-option value="FEMALE">Mme</mat-option>
                      <mat-option value="OTHER">Autre</mat-option>
                    </mat-select>
                  </div>
                  <div>
                    <label for="firstname" class="block text-sm font-medium text-site mb-2">
                      Prénom <span class="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstname"
                      formControlName="firstname"
                      placeholder="Votre prénom"
                      class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
                      />
                    </div>
                  </div>
                  <div class="grid md:grid-cols-2 gap-4">
                    <div>
                      <label for="lastname" class="block text-sm font-medium text-site mb-2">
                        Nom <span class="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="lastname"
                        formControlName="lastname"
                        placeholder="Votre nom"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
                        />
                      </div>
                      <div class="relative">
                        <label for="birthdate" class="block text-sm font-medium text-site mb-2">
                          Date de naissance <span class="text-red-500">*</span>
                        </label>
                        <input
                          matInput
                          [matDatepicker]="pickerFromJournal"
                          (dateChange)="onBirthdateChange($event)"
                          (input)="onBirthdateInput($event)"
                          (click)="pickerFromJournal.open()"
                          (focus)="pickerFromJournal.open()"
                          id="birthdate"
                          formControlName="birthdate"
                          placeholder="Sélectionner une date"
                          class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg outline-none transition"
                          />
                          <!-- Icône positionnée dans l'input -->
                          <mat-datepicker-toggle
                            [for]="pickerFromJournal"
                            class="absolute right-3 cursor-pointer"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #pickerFromJournal></mat-datepicker>
                        </div>
                      </div>
                      <div class="">
                        <label for="register-email" class="block text-sm font-medium text-site mb-2">
                          E-mail <span class="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="register-email"
                          formControlName="email"
                          placeholder="votre.email@exemple.com"
                          class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
                          />
                        </div>
                        <div class="grid md:grid-cols-2 gap-4">
                          <div>
                            <label for="register-email" class="block text-sm font-medium text-site mb-2">
                              Numéro de téléphone <span class="text-red-500">*</span>
                            </label>
                            <div
                              class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg outline-none transition"
                              >
                              <ngx-mat-input-tel
                                [preferredCountries]="['FR', 'US', 'GB']"
                                [enablePlaceholder]="true"
                                [enableSearch]="true"
                                formControlName="phone"
                                >
                              </ngx-mat-input-tel>
                            </div>
                            @if (phoneControl.invalid && (phoneControl.dirty || phoneControl.touched)) {
                              <div
                                class="mt-1.5 min-h-[20px] text-sm text-red-600 font-medium"
                                >
                                @if (phoneControl.invalid) {
                                  <span>
                                    Numéro de téléphone invalide
                                  </span>
                                }
                              </div>
                            }
                          </div>
                          <div class="relative">
                            <label for="register-password" class="block text-sm font-medium text-site mb-2">
                              Mot de passe <span class="text-red-500">*</span>
                            </label>
                            <input
                              (input)="tooltip.show()" matInput
                              matTooltip="Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial"
                              [matTooltipDisabled]="passwordValid"
                              matTooltipPosition="above"
                              [type]="hide ? 'password' : 'text'"
                              #tooltip="matTooltip"
                              type="password"
                              id="register-password"
                              formControlName="password"
                              placeholder="Minimum 8 caractères"
                              class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
                              />
                              <mat-icon
                                (click)="hide = !hide"
                                class="cursor-pointer text-[#7FABFF] absolute right-4 top-[42px]"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hide">
                                {{ hide ? 'visibility_off' : 'visibility' }}
                              </mat-icon>
                            </div>
                          </div>
                          <!-- Birthdate & Gender -->
                          <!-- Submit button -->
                          <button
                            [matButton]="themeConfig.appearance.button.action"
                            type="submit"
          class="w-full  disabled:bg-gray-300  py-4 rounded-[6px]
             flex items-center justify-between px-2 cursor-pointer gap-3 transition transform hover:scale-105 disabled:hover:scale-100"
                            >
                            <span class="flex items-center gap-2">
                              @if (isSubmitting) {
                                <mat-spinner diameter="22"></mat-spinner>
                              }
                              {{ isSubmitting ? 'Inscription...' : 'Je m’inscris' }}
                            </span>

                          </button>
                          <div class="text-center">
                            <span class="text-gray-600">Vous avez déjà un compte ? </span>
                            <a (click)="toggleMode()"
                              class="text-primary hover:text-orange-700 font-semibold underline cursor-pointer">
                              Connectez-vous
                            </a>
                          </div>
                        </form>
                      }
                      @if (isResetPasswordMode && !isResetMode && !isLoginMode) {
                        <form  [formGroup]="resetPasswordForm" (ngSubmit)="onResetNewPassword()" class="flex flex-col gap-[10px]">
                          <div class="relative">
                            <label class="block text-sm font-medium text-gray-700 mb-2">
                              Nouveau mot de passe <span class="text-red-500">*</span>
                            </label>
                            <input
                              (input)="tooltipNewPassword.show()" matInput
                              matTooltip="Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial"
                              [matTooltipDisabled]="newPasswordValid"
                              matTooltipPosition="above"
                              [type]="hideNew ? 'password' : 'text'"
                              #tooltipNewPassword="matTooltip"
                              type="password"
                              id="new-password"
                              formControlName="newPassword"
                              class="w-full px-4 py-3 border border-gray-300 rounded-lg  outline-none transition"
                              />
                              <mat-icon
                                (click)="hideNew = !hideNew"
                                class="cursor-pointer text-[#7FABFF] absolute right-4 bottom-3"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hideNew">
                                {{ hideNew ? 'visibility_off' : 'visibility' }}
                              </mat-icon>
                            </div>
                            <div class="relative">
                              <label class="block text-sm font-medium text-gray-700 mb-2">
                                Confirmer le nouveau mot de passe <span class="text-red-500">*</span>
                              </label>
                              <input
                                (input)="tooltipRetypePassword.show()" matInput
                                matTooltip="Les nouveaux mot de passe ne correspondent pas"
                                [matTooltipDisabled]="!resetPasswordForm.hasError('mismatch')"
                                matTooltipPosition="above"
                                [type]="hideRetype ? 'password' : 'text'"
                                #tooltipRetypePassword="matTooltip"
                                type="password"
                                id="retype-password"
                                formControlName="retypePassword"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none transition"
                                />
                                <mat-icon
                                  (click)="hideRetype = !hideRetype"
                                  class="cursor-pointer text-[#7FABFF] absolute right-4 bottom-3"
                                  [attr.aria-label]="'Hide password'"
                                  [attr.aria-pressed]="hideRetype">
                                  {{ hideRetype ? 'visibility_off' : 'visibility' }}
                                </mat-icon>
                              </div>
                              <button type="submit"
                                [disabled]="resetPasswordForm.invalid || isSubmitting"
          class="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 text-white  py-4 rounded-[6px]
             flex items-center justify-between px-2 cursor-pointer gap-3 transition transform hover:scale-105
             disabled:hover:scale-100 ">
                                <span class="flex items-center justify-center gap-2">
                                  @if (isSubmitting) {
                                    <mat-spinner diameter="22"></mat-spinner>
                                  }
                                  {{ isSubmitting ? 'Confirmer...' : 'Confirmer' }}
                                </span>
                              </button>
                            </form>
                          }
                        </mat-dialog-content>
                      </div>

